import React from "react";
import {
  FaInstagram,
  FaFacebook,
  FaSoundcloud,
  FaTwitter,
} from "react-icons/fa";

import "../App.css";
import Calum3 from "../images/calum3.jpg";

function Calum() {
  return (
    <div>
      <div className="flex__layout">
        <div className="artist__description" data-aos="fade-down">
          <h1>Calum Venice</h1>
          <br />
          <h3>
            As an independent singer / songwriter / producer, Calum Venice
            asserts his musical identity.
          </h3>
          <br />
          <p>
            He is a self-taught producer and his early mixtapes were crucial
            towards the development of his signature sound. Having been
            influenced by early 1960’s Motown music, Calum contrasts his lyrics
            with a powerful vocal and manages to expose his soul in every piece
            of music he creates.
          </p>
          <br />
          <p>
            He exhibits a vocal maturity well beyond his years, with his piano
            playing laying the perfect foundation to compliment his vocals.
            Locally he received a wide array of attention and began performing
            originals in song-writing competitions.He eventually secured a
            national TV appearance on Scottish National Television (STV.)
          </p>
          <br />
          <p>
            At an international level Calum has established and demonstrated his
            song-writing abilities, developing a lot of attention from labels,
            managers and other artists. More recently Calum has ghost written
            for many upcoming artists and his style has spanned over a wide
            variety of genres; including house, dance, soul, R&B, rap, pop and
            rock.
          </p>
          <br />
          <p>
            Many of his writing and vocal features have gathered hundreds of
            thousands of listens on radio and online, including Spotify and
            Soundcloud. 
          </p>
          <br />
          <div className="social__media__icons">
            <li>
              <a
                href="https://www.instagram.com/calumvenice/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <p>
                  <FaInstagram fill="white" size={40} />
                </p>
              </a>
            </li>
            <li>
              <a
                href="https://www.facebook.com/Calum-Venice-257622811090219/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <p>
                  <FaFacebook fill="white" size={40} />
                </p>
              </a>
            </li>
            <li>
              <a
                href="https://twitter.com/calumvenice?lang=en"
                target="_blank"
                rel="noopener noreferrer"
              >
                <p>
                  <FaTwitter fill="white" size={40} />
                </p>
              </a>
            </li>
            <li>
              <a
                href="https://soundcloud.com/calumvenice"
                target="_blank"
                rel="noopener noreferrer"
              >
                <p>
                  <FaSoundcloud fill="white" size={40} />
                </p>
              </a>
            </li>
          </div>
        </div>

        {/*Photos or Videos + playlist.*/}
        <div>
          <div className="__photos" data-aos="fade-up">
            <img src={Calum3} className="artists__photo__size" />
          </div>
        </div>
      </div>

      <div className="spotify__playlist" data-aos="fade-right">
        <iframe
          src="https://open.spotify.com/embed/playlist/4ian23fI5a9rWU7k5EzLY8?utm_source=generator&theme=0"
          width="800"
          height="380"
          frameBorder="0"
          allowfullscreen=""
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        ></iframe>
      </div>
    </div>
  );
}

export default Calum;
